export const ManagementAdminsDialogStyle = {
  header: {
    backgroundColor: "#64b5f6",

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    width: "100%",
    position: "relative", // ×ボタン用
    paddingTop: 2,
    paddingBottom: 2,
  },
  headerText: {
    color: "white",
    fontWeight: "bold",
  },

  closeButton: {
    position: "absolute",
    top: 10,
    right: 20,
    color: "#000",
    fontWeight: "bold",
    minWidth: 48,
    padding: "2px 8px",
    fontSize: "28px",
    lineHeight: 1,
  },
  formArea: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 4,
    // position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    flexDirection: "column",
    textAlign: "center",
    gap: 0.5,
  },

  floatingRegisterButton: {
    position: "absolute",
    bottom: 24, // ダイアログ下からの距離
    right: 24, // ダイアログ右からの距離
    width: 90,
    height: 90,
    borderRadius: "50%",
    backgroundColor: "#e0a56d",
    color: "white",
    fontWeight: "bold",
    boxShadow: 6,
    zIndex: 2000,
    "&:hover": {
      backgroundColor: "#d79652",
    },
  },

  inputRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 1,
    width: "100%",
  },
  label: {
    minWidth: "140px",
    textAlign: "right",
  },
};
